import API_URL from "../config/config";
import axios from "axios";
export const getDigitalLearner = async ({ user_id, assessment_id }) => {
  const url = assessment_id
    ? `${API_URL}/dashboard/dashbronzeandgold/${user_id}/${assessment_id}`
    : `${API_URL}/dashboard/bronzeandgold/${user_id}`;
  try {
    return await axios.get(url);
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};
